import { t } from 'i18next';

export interface ProyectosGlosaFormValues {
  dicprog_nombre_proyecto: string;
  dicprog_fecha_validez_inicio: Date | undefined;
  dicprog_fecha_validez_fin: Date | undefined;
  dicprog_activo: boolean;
}

export interface ProyectosGlosaErrors {
  dicprog_nombre_proyecto?: string;
  dicprog_fecha_validez_inicio?: string;
  dicprog_fecha_validez_fin?: string;
}

export function validateProyectosGlosa(values: ProyectosGlosaFormValues): ProyectosGlosaErrors {
  const errors: ProyectosGlosaErrors = {};

  if (!values.dicprog_nombre_proyecto.trim()) {
    errors.dicprog_nombre_proyecto = t('El nombre del proyecto es requerido');
  }

  if (!values.dicprog_fecha_validez_inicio) {
    errors.dicprog_fecha_validez_inicio = t('La fecha de inicio de vigencia es requerida');
  }

  if (!values.dicprog_fecha_validez_fin) {
    errors.dicprog_fecha_validez_fin = t('La fecha de fin de vigencia es requerida');
  }

  if (values.dicprog_fecha_validez_inicio && values.dicprog_fecha_validez_fin) {
    if (values.dicprog_fecha_validez_fin <= values.dicprog_fecha_validez_inicio) {
      errors.dicprog_fecha_validez_fin = t('La fecha de fin debe ser posterior a la fecha de inicio');
    }
  }

  return errors;
}

export function hasErrors(errors: ProyectosGlosaErrors): boolean {
  return Object.values(errors).some((error) => error !== undefined);
}
